import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CarbonFootprintsPage } from '@/areas/settings/procurement-intelligence/OrganizationSettings/CarbonFootprintsPage/CarbonFootprintsPage';
import { canViewCarbonFootprintsSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/carbon-footprints')({
    staticData: { access: { permissions: canViewCarbonFootprintsSettings }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CarbonFootprintsPage />;
}
